export default "__VITE_ASSET__EnC98vw7__"